<template>
  <div>
    <v-menu
        :scroll-pos="scrollPos"
    />
    <v-header />

    <v-section-summary />
    <v-section-features />
    <v-section-data />
    <v-section-pricing />
    <v-section-register />

    <v-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import Data from '@/components/sections/Data.vue';
import Features from '@/components/sections/Features.vue';
import Pricing from '@/components/sections/Pricing.vue';
import Register from '@/components/sections/Register.vue';
import Summary from '@/components/sections/Summary.vue';

export default {
  name: 'Home',
  components: {
    'v-footer': Footer,
    'v-header': Header,
    'v-menu': Menu,
    'v-section-data': Data,
    'v-section-features': Features,
    'v-section-pricing': Pricing,
    'v-section-register': Register,
    'v-section-summary': Summary,
  },
  data() {
    return {
      scrollPos: 0,
    };
  },
  methods: {
    handleScroll() {
      this.scrollPos = window.scrollY;
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
};
</script>

<style>
@import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
@import "../../node_modules/bootstrap/dist/css/bootstrap-reboot.min.css";
@import "../assets/css/style.css";
</style>
